import { render, staticRenderFns } from "./reserves-table.vue?vue&type=template&id=b4c3557c&scoped=true"
import script from "./reserves-table.vue?vue&type=script&lang=js"
export * from "./reserves-table.vue?vue&type=script&lang=js"
import style0 from "./reserves-table.vue?vue&type=style&index=0&id=b4c3557c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c3557c",
  null
  
)

export default component.exports